var customClient = [{
        "name": "Amberline",
        "guid": "dc8cb3cb-9a9f-43b1-8660-5cae99a1b00e",
        "shortName": "amberline",
        "apiUrl": "https://serwis.amberline.eu/backend/api/custom/",
        "validation": {
            "default": [
                "type_of_client",
                "customer_name",
                "customer_email",
                "complaint_phonenumber",
                "area",
                "customer_address_postcode",
                "customer_address_city",
                "customer_address_street",
                "customer_address_number",
                "product_name",
                "item_from_an_order_or_invoice",
                "product_amount",
                "order_date",
                "complaint_description",
                "privacyPolicy"
            ],
            "dealer": [
                "type_of_client",
                "customer_company_name",
                "order_number",
                "reporting_claims_person",
                "customer_email",
                "complaint_phonenumber",
                "area",
                "customer_address_postcode",
                "customer_address_city",
                "customer_address_street",
                "customer_address_number",
                "product_name",
                "item_from_an_order_or_invoice",
                "product_amount",
                "phone_number_owner_of_local",
                "order_date",
                "complaint_description",
                "privacyPolicy"
            ],
            "investor": [
                "type_of_client",
                "customer_investor_name",
                "number_of_invoice",
                "reporting_claims_person",
                "customer_email",
                "complaint_phonenumber",
                "area",
                "order_number",
                "customer_address_postcode",
                "customer_address_city",
                "customer_address_street",
                "customer_address_number",
                "phone_number_owner_of_local",
                "product_name",
                "item_from_an_order_or_invoice",
                "product_amount",
                "order_date",
                "complaint_description",
                "privacyPolicy"
            ],
            "individual_customer": [
                "type_of_client",
                "customer_name",
                "customer_email",
                "complaint_phonenumber",
                "area",
                "customer_address_postcode",
                "customer_address_city",
                "customer_address_street",
                "customer_address_number",
                "product_name",
                "item_from_an_order_or_invoice",
                "product_amount",
                "complaint_description",
                "order_date",
                "privacyPolicy"
            ]
        },
        "dictionaries": {
            "clientTypes": [
                {
                    "label": {
                        "pl": "Klient indywidualny",
                        "en": "Private customer",
                        "de": "Endverbraucher"
                    },
                    "key": "individual_customer"
                },
                {
                    "label": {
                        "pl": "Diler",
                        "en": "Dealer",
                        "de": "Geschäftspartner"
                    },
                    "key": "dealer"
                },
                {
                    "label": {
                        "pl": "Inwestor",
                        "en": "Investor",
                        "de": "Investor"
                    },
                    "key": "investor"
                }
            ],
            "productName": [
                {
                  "key": "pcv",
                  "label": {
                    "en": "PVC windows",
                    "pl": "Okna pcv",
                    "de": "PVC Fenster"
                  }
                },
                {
                  "key": "alu",
                  "label": {
                    "en": "Aluminum windows",
                    "pl": "Okna alu",
                    "de": "Aluminiumfenster"
                  }
                },
                {
                  "key": "blinds",
                  "label": {
                    "en": "Roller blinds",
                    "pl": "Rolety",
                    "de": "Rollos"
                  }
                },
                {
                  "key": "gates",
                  "label": {
                    "en": "Gates",
                    "pl": "Bramy",
                    "de": "Tore"
                  }
                },
                {
                  "key": "fittings",
                  "label": {
                    "en": "Fittings",
                    "pl": "Okucia",
                    "de": "Armaturen"
                  }
                },
                {
                  "key": "glazing_packages",
                  "label": {
                    "en": "Glazing packages",
                    "pl": "Pakiety szybowe",
                    "de": "Verglasungspakete"
                  }
                },
                {
                  "key": "other",
                  "label": {
                    "en": "Other",
                    "pl": "Inne",
                    "de": "Andere"
                  }
                }
              ],
            "area": [
                {
                  "key": "local_kkbdio",
                  "label": {
                    "en": "Poland: Kołobrzeg, Koszalin, Białogard, Dźwirzyno and surroundings",
                    "pl": "Miejscowe: Kołobrzeg, Koszalin, Białogard, Dźwirzyno i okolice",
                    "de": "Polen: Kołobrzeg, Koszalin, Białogard, Dźwirzyno und Umfeld"
                  },
                  "order":{
                    "pl": 0,
                    "en": 5,
                    "de": 5
                  }
                },
                {
                  "key": "poland_sgmg",
                  "label": {
                    "en": "Poland: Słupsk, Gdańsk, Malbork, Grudziądz",
                    "pl": "Słupsk, Gdańsk, Malbork, Grudziądz",
                    "de": "Polen: Słupsk, Gdańsk, Malbork, Grudziądz"
                  },
                  "order":{
                    "pl": 1,
                    "en": 6,
                    "de": 6
                  }
                },
                {
                  "key": "poland_spgss",
                  "label": {
                    "en": "Poland: Szczecin, Płoty, Gryfice, Stargard Szczeciński",
                    "pl": "Szczecin, Płoty, Gryfice, Stargard Szczeciński",
                    "de": "Polen: Szczecin, Płoty, Gryfice, Stargard Szczeciński"
                  },
                  "order":{
                    "pl": 2,
                    "en": 7,
                    "de": 7
                  }
                },
                {
                  "key": "poland_zgzw",
                  "label": {
                    "en": "Poland: Zielona Góra, Żary, Wrocław",
                    "pl": "Zielona Góra, Żary, Wrocław",
                    "de": "Polen: Zielona Góra, Żary, Wrocław"
                  },
                  "order":{
                    "pl": 3,
                    "en": 8,
                    "de": 8
                  }
                },
                {
                  "key": "poland_gwssplom",
                  "label": {
                    "en": "Poland: Gorzów Wlkp., Świebodzin, Sulechów, Poznań, Leszno, Opalenica, Międzyrzecz",
                    "pl": "Gorzów Wlkp., Świebodzin, Sulechów, Poznań, Leszno, Opalenica, Międzyrzecz",
                    "de": "Polen: Gorzów Wlkp., Świebodzin, Sulechów, Poznań, Leszno, Opalenica, Międzyrzecz"
                  },
                  "order":{
                    "pl": 4,
                    "en": 9,
                    "de": 9
                  }
                },
                {
                  "key": "poland_bktl",
                  "label": {
                    "en": "Poland: Błaszki, Konin, Turek, Łódź",
                    "pl": "Błaszki, Konin, Turek, Łódź",
                    "de": "Polen: Błaszki, Konin, Turek, Łódź",
                  },
                  "order":{
                    "pl": 5,
                    "en": 10,
                    "de": 10
                  }
                },
                {
                  "key": "poland_wrzgp",
                  "label": {
                    "en": "Poland: Warszawa, Radom, Żyrardów, Grójec, Pruszków",
                    "pl": "Warszawa, Radom, Żyrardów, Grójec, Pruszków",
                    "de": "Polen: Warszawa, Radom, Żyrardów, Grójec, Pruszków"
                  },
                  "order":{
                    "pl": 6,
                    "en": 11,
                    "de": 11
                  }
                },
                {
                  "key": "poland_cws",
                  "label": {
                    "en": "Poland: Chojnice, Wałcz, Szczecinek",
                    "pl": "Chojnice, Wałcz, Szczecinek",
                    "de": "Polen: Chojnice, Wałcz, Szczecinek"
                  },
                  "order":{
                    "pl": 7,
                    "en": 12,
                    "de": 12
                  }
                },
                {
                  "key": "germany",
                  "label": {
                    "en": "Germany",
                    "pl": "Niemcy",
                    "de": "Deutschland"
                  },
                  "order":{
                    "pl": 8,
                    "en": 0,
                    "de": 0
                  }
                },
                {
                  "key": "sweden",
                  "label": {
                    "en": "Sweden",
                    "pl": "Szwecja",
                    "de": "Schweden"
                  },
                  "order":{
                    "pl": 9,
                    "en": 1,
                    "de": 1
                  }
                },
                {
                  "key": "norway",
                  "label": {
                    "en": "Norway",
                    "pl": "Norwegia",
                    "de": "Norwegen"
                  },
                  "order":{
                    "pl": 10,
                    "en": 2,
                    "de": 2
                  }
                },
                {
                  "key": "ireland",
                  "label": {
                    "en": "Ireland",
                    "pl": "Irlandia",
                    "de": "Irland"
                  },
                  "order":{
                    "pl": 11,
                    "en": 3,
                    "de": 3
                  }
                },
                {
                  "key": "italy",
                  "label": {
                    "en": "Italy",
                    "pl": "Włochy",
                    "de": "Italien"
                  },
                  "order":{
                    "pl": 12,
                    "en": 4,
                    "de": 4
                  }
                },
                {
                  "key": "other",
                  "label": {
                    "en": "other",
                    "pl": "inne",
                    "de": "andere"
                  },
                  "order":{
                    "pl": 1000,
                    "en": 1000,
                    "de": 1000
                  }
                }
              ]
        }
    }];

export default customClient;